// #region Imports
import { createSelector, createSlice } from "@reduxjs/toolkit";
import SearchResults from "_shared/_api/search/search-results";
import { RootState } from "_shared/_stores/redux-store";
import { marketplaceApi } from "marketplace/_api/marketplace-api";
import { MarketplaceSearchInfoJSON } from "marketplace/_schema/marketplace-search-response-schema";
import { ForumJSON } from "messaging/forums/_schemas/forum-schema";
// #endregion

// #region Store State Type
export type MarketplaceStoreState = {
  searchAll: {
    entries?: SearchResults<MarketplaceSearchInfoJSON>;
  };
  forums: {
    entries?: ForumJSON[];
  };
};
// #endregion

// #region Initial State
const initialState: MarketplaceStoreState = {
  searchAll: {
    entries: undefined,
  },
  forums: {
    entries: undefined,
  },
};
// #endregion

// #region Slice
export const marketplaceSlice = createSlice({
  name: "marketplace",
  initialState,
  reducers: {
    clearMarketplaceSearchAll(state) {
      state.searchAll.entries = undefined;
    },
    clearMarketplaceForums(state) {
      state.forums.entries = undefined;
    },
  },
  extraReducers: (builder) => {
    // #region RTK Query matchers
    builder.addMatcher(marketplaceApi.endpoints.searchAll.matchFulfilled, (state, action) => {
      state.searchAll.entries = action.payload;
    });

    builder.addMatcher(marketplaceApi.endpoints.getMarketplaceForums.matchFulfilled, (state, action) => {
      state.forums.entries = action.payload;
    });
  },
});
// #endregion

// #region Exports
export const { clearMarketplaceSearchAll, clearMarketplaceForums } = marketplaceSlice.actions;

// #region Selectors

// searchAll
const selectMarketplaceSearchAll = createSelector(
  [(state: RootState) => state.marketplace.searchAll.entries],
  (entries) => entries ?? new SearchResults<MarketplaceSearchInfoJSON>({})
);
export const getMarketplaceSearchAll = () => (state: RootState) => selectMarketplaceSearchAll(state);

export const getMarketplaceSearchAllIsLoading = () => (_state: RootState) => false;
export const getMarketplaceSearchAllError = () => (_state: RootState) => null;

// forums
const selectMarketplaceForums = createSelector(
  [(state: RootState) => state.marketplace.forums.entries],
  (entries) => entries ?? []
);
export const getMarketplaceForums = () => (state: RootState) => selectMarketplaceForums(state);

export const getMarketplaceForumsIsLoading = () => (_state: RootState) => false;
export const getMarketplaceForumsError = () => (_state: RootState) => null;

// #endregion
// #endregion
